// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__oa359","emails":"CreateEditClinics_emails__1QXjL","emailTagLabel":"CreateEditClinics_emailTagLabel__tal1J"};